import { ArrowUpDown } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { auctionsLabels } from "@/i18n";
import { NativeSelectField } from "@/components/native/NativeSelectField";

interface MyAuctionsSortDropdownProps {
  sortBy: string;
  setSortBy: (sortBy: string) => void;
  type: "active" | "sold";
}

export const MyAuctionsSortDropdown = ({
  sortBy,
  setSortBy,
}: MyAuctionsSortDropdownProps) => {
  const { language } = useLanguage();
  const sortLabels = auctionsLabels(language).myAuctions.sort;

  const options = [
    { value: "updated", label: sortLabels.updated },
    { value: "newest", label: sortLabels.newest },
    { value: "oldest", label: sortLabels.oldest },
    { value: "price-high-low", label: sortLabels.priceHighLow },
    { value: "price-low-high", label: sortLabels.priceLowHigh },
  ];

  return (
    <div className="flex justify-end">
      <div className="flex items-center gap-2">
        <span className="text-sm text-muted-foreground">
          {sortLabels.placeholder}
        </span>
        <NativeSelectField
          value={sortBy}
          onValueChange={setSortBy}
          options={options}
          title={sortLabels.placeholder}
          triggerClassName="w-[160px] bg-card"
          renderOptionLabel={(opt) => (
            <div className="flex items-center gap-2">
              <ArrowUpDown className="h-4 w-4" />
              {opt.label}
            </div>
          )}
        />
      </div>
    </div>
  );
};
